export const LAUNCH_INIT = '@EKKO/LAUNCH_INIT'
export const SET_CURRENT_APP_ID = '@EKKO/SET_CURRENT_APP_ID'
export const LOAD_CURRENT_APPLICATION_REQUEST = '@EKKO/LOAD_CURRENT_APPLICATION_REQUEST'
export const SET_CURRENT_APPLICATION = '@EKKO/SET_CURRENT_APPLICATION'
export const SET_CURRENT_APPLICATION_LOADING = '@EKKO/SET_CURRENT_APPLICATION_LOADING'
export const CHANGE_WEBHOOK_URL_REQUEST = '@EKKO/CHANGE_WEBHOOK_URL_REQUEST'
export const CHANGE_ACCESS_RESTRICTED_REQUEST = '@EKKO/CHANGE_ACCESS_RESTRICTED_REQUEST'
export const CHANGE_ALLOW_SECURITY_URL_REQUEST = '@EKKO/CHANGE_ALLOW_SECURITY_URL_REQUEST'
export const CHANGE_AUTHENTICATION_IN_CHAT_REQUEST = '@EKKO/CHANGE_AUTHENTICATION_IN_CHAT_REQUEST'
export const CHANGE_NOW_SETTINGS_REQUEST = '@EKKO/CHANGE_NOW_SETTINGS_REQUEST'
export const CHANGE_NOW_NOTIFICATION_REQUEST = '@EKKO/CHANGE_NOW_NOTIFICATION_REQUEST'
